(() => {
  'use strict';
  if (window.mmFindMikeInitialized) return;
  const main = document.getElementById('MainContent'), button = document.querySelector('[data-mm-mike-pose]'), dialog = document.getElementById('MMFindMikeDialog'), tab = document.querySelector('[data-mm-mike-tab]');
  if (!main || !button || !dialog || !tab) return;
  window.mmFindMikeInitialized = true;
  const key = 'mm-find-mike-v1', pendingKey = 'mm-find-mike-signup-pending-v2';
  const valid = value => Array.isArray(value) ? [...new Set(value.filter(pose => (typeof pose === 'string' && /^[0-5]$/.test(pose)) || (typeof pose === 'number' && Number.isInteger(pose) && pose >= 0 && pose <= 5)).map(String))] : [];
  const get = (storage, name) => { try { return storage?.getItem(name); } catch (_) { return null; } };
  const put = (storage, name, value) => { try { storage?.setItem(name, value); } catch (_) {} };
  const local = () => { try { return window.localStorage; } catch (_) { return null; } };
  const session = () => { try { return window.sessionStorage; } catch (_) { return null; } };
  const parse = value => { try { return valid(JSON.parse(value || '[]')); } catch (_) { return []; } };
  const read = () => valid([...parse(get(local(),key)),...parse(get(session(),key))]);
  const random = () => { try { const values = new Uint32Array(1); window.crypto.getRandomValues(values); return values[0] / 4294967296; } catch (_) { return Math.random(); } };
  const choose = values => values[Math.floor(random() * values.length)];
  let found = read(), trigger = null, retreated = false, submitting = false;
  const es = dialog.dataset.mmMikeLanguage === 'es', title = dialog.querySelector('[data-mm-mike-title]'), message = dialog.querySelector('[data-mm-mike-message]');
  const pendingAt = Number(get(session(),pendingKey));
  const recentRequest = pendingAt > 0 && Date.now() >= pendingAt && Date.now() - pendingAt < 30 * 60 * 1000;
  const requestReceived = !!dialog.querySelector('[data-mm-mike-signup-success]') && recentRequest && found.length === 6;
  let showRequestReference = requestReceived;
  if (requestReceived) put(session(),pendingKey,'');
  const missing = ['0','1','2','3','4','5'].filter(pose => !found.includes(pose));
  const pose = choose(missing.length ? missing : ['0','1','2','3','4','5']);
  button.dataset.mmMikePose = pose;
  button.querySelector('.mm-mike-sprite').className = 'mm-mike-sprite mm-mike-sprite--' + pose;
  const rendered = node => {
    if (!node || node.closest('[hidden],[inert],[aria-hidden="true"],dialog:not([open])')) return false;
    for (let ancestor = node; ancestor && ancestor.nodeType === 1; ancestor = ancestor.parentElement) {
      const style = window.getComputedStyle(ancestor);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    const rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };
  const activeInViewport = node => {
    if (!rendered(node)) return false;
    const rect = node.getBoundingClientRect();
    return rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
  };
  const anotherInterfaceActive = () => Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],#mm-subscription-popup[aria-hidden="false"],[data-mm-cookie-consent],.mc-modal,.mc-banner,.smile-panel-frame-container,cart-drawer.active,cart-drawer[open],.r32-header details[open]')).some(node => {
    if (node === dialog || dialog.contains(node)) return false;
    if (node.matches('[data-r32-navigation]') && !rendered(node.querySelector(':scope > summary'))) return false;
    return activeInViewport(node);
  });
  const update = () => {
    document.querySelectorAll('[data-mm-mike-count]').forEach(node => { node.textContent = found.length + ' / 6'; });
    button.setAttribute('aria-pressed', String(found.includes(pose)));
    dialog.querySelectorAll('[data-mm-mike-claim]').forEach(node => { node.hidden = found.length !== 6 || showRequestReference; });
  };
  const open = (source, spotted) => {
    if (anotherInterfaceActive()) return false;
    trigger = source;
    title.textContent = spotted ? (es ? '¡Encontraste a Mike!' : 'You found Mike!') : (es ? '¿Dónde está Mike?' : 'Where’s Mike?');
    dialog.querySelector('[data-mm-mike-pop]').className = 'mm-mike-pop mm-mike-sprite mm-mike-sprite--' + pose;
    message.textContent = showRequestReference
      ? (es ? 'Solicitud de email recibida.' : 'Email signup received.')
      : found.length === 6
        ? (es ? '¡Encontraste las seis poses!' : 'You found all six poses!')
        : (spotted ? (es ? '¡Una pose más para tu colección!' : 'Another pose for your collection!') : '');
    if (!dialog.open) {
      try {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open','');
      } catch (_) { return false; }
      document.body.classList.add('mm-find-mike-open');
      tab.setAttribute('aria-expanded','true');
      dialog.querySelector('[data-mm-mike-close]').focus({preventScroll:true});
    }
    return true;
  };
  const restoreFocus = () => {
    document.body.classList.remove('mm-find-mike-open');
    tab.setAttribute('aria-expanded','false');
    const target = trigger && !trigger.disabled && rendered(trigger) ? trigger : tab;
    if (target && rendered(target)) target.focus({preventScroll:true});
  };
  const retreat = () => {
    retreated = true; button.disabled = true;
    const hide = () => { button.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) { hide(); return; }
    button.classList.add('mm-mike-retreat');
    button.addEventListener('animationend', hide, {once:true});
    window.setTimeout(hide, 360);
  };
  const close = () => { if (!dialog.open) return; if (typeof dialog.close === 'function') dialog.close(); else { dialog.removeAttribute('open'); restoreFocus(); } };
  dialog.querySelector('[data-mm-mike-close]').addEventListener('click', close);
  dialog.addEventListener('close', restoreFocus);
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(rendered);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  tab.addEventListener('click', event => { if (open(tab,false)) event.preventDefault(); });
  button.addEventListener('click', () => {
    if (retreated || anotherInterfaceActive()) return;
    const wasFound = found.includes(pose);
    found = valid([...found, ...read(), pose]);
    put(local(), key, JSON.stringify(found)); put(session(), key, JSON.stringify(found));
    retreat(); update(); open(tab,true);
    if (wasFound && found.length !== 6) message.textContent = es ? 'Ya encontraste esta pose. ¡Busca los otros escondites!' : 'You already found this pose. Keep looking for the others!';
  });
  const form = document.getElementById('MMFindMikeSignup');
  const submitButton = form?.querySelector('[type="submit"]');
  const resetSubmit = () => { submitting=false; if (submitButton) submitButton.disabled=false; form?.removeAttribute('aria-busy'); };
  if (form) form.addEventListener('submit', event => {
    const consent = form.querySelector('[name="mm_mike_consent"]');
    if (submitting || found.length !== 6 || (consent && !consent.checked) || !form.checkValidity()) {
      event.preventDefault(); if (!submitting) form.reportValidity(); return;
    }
    window.queueMicrotask(() => {
      if (event.defaultPrevented || !form.isConnected || submitting) return;
      submitting = true;
      if (submitButton) submitButton.disabled = true;
      form.setAttribute('aria-busy','true');
      put(session(),pendingKey,String(Date.now())); put(session(),key,JSON.stringify(found));
      window.setTimeout(resetSubmit,15000);
    });
  });
  window.addEventListener('pageshow', resetSubmit);
  const excluded = 'header,nav,footer,form,button,input,select,textarea,dialog,[role="button"],[data-mm-mike-seed],ins,[data-mm-ad-slot]';
  const targets = () => {
    const nodes = main.querySelectorAll('img,p,h2,h3');
    const limit = Math.min(nodes.length, 72);
    const picks = new Set();
    if (nodes.length <= limit) {
      for (let i = 0; i < nodes.length; i++) picks.add(i);
    } else {
      while (picks.size < limit) picks.add(Math.floor(random() * nodes.length));
    }
    return [...picks].map(index => nodes[index]).filter(node => {
      if (!node || node.closest(excluded) || node.closest('[hidden]')) return false;
      const r = node.getBoundingClientRect();
      return r.width >= (node.tagName === 'IMG' ? 100 : 180) && r.height >= (node.tagName === 'IMG' ? 70 : 28);
    });
  };
  const size = () => window.matchMedia('(max-width:749px)').matches ? 64 : 80;
  const overlaps = (a,b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  let target = null, corner = 0, observer = null;
  const location = (node,point) => {
    const r = node.getBoundingClientRect(), h = main.getBoundingClientRect(), width = size(), height = Math.round(width * .7);
    const right = point % 2 === 1, bottom = point > 1;
    const pageLeft = Math.max(h.left, 4), pageRight = Math.min(h.right, document.documentElement.clientWidth - 4);
    const x = Math.max(pageLeft, Math.min(r.left + (right ? r.width - width : 0), pageRight - width));
    const y = bottom ? r.bottom - 6 : r.top - height + 6;
    return {left:x-h.left,top:y-h.top,width,height,rect:{left:x,right:x+width,top:y,bottom:y+height}};
  };
  const obstacles = () => {
    const blocks = Array.from(main.querySelectorAll('button,input,select,textarea,[role="button"],iframe,ins,img'))
      .filter(el => el !== button)
      .map(el => ({node: el, rect: el.getBoundingClientRect()}))
      .filter(entry => entry.rect.width > 0 && entry.rect.height > 0);
    const walker = document.createTreeWalker(main, window.NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) {
      if (!text.textContent.trim() || !text.parentElement || text.parentElement.closest('script,style,svg,dialog,[hidden],.mm-mike-scout')) continue;
      const range = document.createRange(); range.selectNodeContents(text);
      Array.from(range.getClientRects()).forEach(r => {
        if (r.width > 0 && r.height > 0) blocks.push({node: text.parentElement, rect: r});
      });
    }
    return blocks;
  };
  const fits = (at,blocks,candidate) => {
    const bounds = main.getBoundingClientRect();
    return at.rect.top >= bounds.top && at.rect.bottom <= bounds.bottom && at.rect.left >= 0 && at.rect.right <= document.documentElement.clientWidth && !blocks.some(entry => entry.node !== candidate && overlaps(at.rect,entry.rect));
  };
  const apply = blocks => {
    if (retreated || !target || !target.isConnected) return false;
    const at = location(target,corner), collisionMap = blocks || obstacles();
    if (!fits(at,collisionMap,target)) return false;
    if (window.getComputedStyle(main).position === 'static') main.classList.add('mm-mike-host');
    if (button.parentElement !== main) main.appendChild(button);
    button.hidden = false;
    button.style.left = at.left + 'px'; button.style.top = at.top + 'px';
    button.style.setProperty('--mm-mike-size', at.width + 'px');
    return true;
  };
  const place = () => {
    if (retreated) return false;
    const choices = targets(), blocks = obstacles();
    let attempts = 0;
    while (choices.length && attempts < 18) {
      attempts++;
      const index = Math.floor(random()*choices.length), candidate = choices.splice(index,1)[0];
      const first = Math.floor(random()*4);
      for (let i=0;i<4;i++) {
        const point = (first+i)%4, at = location(candidate,point);
        if (!fits(at,blocks,candidate)) continue;
        target=candidate;corner=point;
        if (apply(blocks)) return true;
      }
    }
    button.hidden = true;
    return false;
  };
  let placementScheduled = false;
  const schedulePlacement = () => {
    if (retreated || placementScheduled) return;
    placementScheduled = true;
    const run = () => {
      placementScheduled = false;
      if (retreated) return;
      if (!target || !target.isConnected || button.hidden) place();
      else if (!apply()) place();
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run,{timeout:1200});
    else window.setTimeout(run,180);
  };
  tab.hidden = false; update(); schedulePlacement();
  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer=window.setTimeout(schedulePlacement,180);
  },{passive:true});
  main.addEventListener('load', event => {
    if (!retreated && event.target.tagName === 'IMG' && (button.hidden || !target?.isConnected)) schedulePlacement();
  },true);
  if (typeof window.MutationObserver === 'function') {
    observer = new window.MutationObserver(() => {
      if (!retreated && (button.hidden || !target?.isConnected)) schedulePlacement();
    });
    observer.observe(main,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:load', schedulePlacement);
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      found=valid([...found,...read()]);update();
    }
  });
  if (requestReceived || document.querySelector('[data-mm-mike-signup-errors]')) {
    let reopenAttempts = 0;
    const reopen = () => {
      if (open(tab, false)) return;
      if (++reopenAttempts < 60) window.setTimeout(reopen, 1000);
    };
    reopen();
  }
})();

